import {
	ICrudApplyCustomerAttrFilters,
	ICrudApplyCustomerAttrFiltersRes,
	ICrudApplyCustomerAttrIndividual,
	ICrudApplyCustomerAttrIndividualRes,
	ICrudCustomerAttrGlobalAssign,
	ICrudCustomerAttrGlobalAssignConfirm,
	ICrudCustomerAttrGlobalAssignConfirmRes,
	ICrudCustomerAttrGlobalAssignEdit,
	ICrudCustomerAttrGlobalAssignEditRes,
	ICrudCustomerAttrGlobalAssignPaginate,
	ICrudCustomerAttrGlobalAssignPaginateRes,
	ICrudCustomerAttrGlobalAssignResponse
} from 'models/CustomerGlobalUploadInterface'
import {
	CLEAR_CUSTOMER_ATTR_GLOBAL,
	EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_CUSTOMER_ATTR_GLOBAL_FILTERS,
	SET_CUSTOMER_ATTR_GLOBAL_FILTERS_SUCCESS,
	SET_CUSTOMER_ATTR_INDIVIDUAL,
	SET_CUSTOMER_ATTR_INDIVIDUAL_SUCCESS
} from '../constants/ActionsTypes'

export const customerAttrGlobalApply = (
	payload: ICrudApplyCustomerAttrFilters
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_FILTERS,
		payload
	}
}

export const customerAttrGlobalApplySuccess = (
	payload: ICrudApplyCustomerAttrFiltersRes
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_FILTERS_SUCCESS,
		payload
	}
}
export const customerAttrIndividualApply = (
	payload: ICrudApplyCustomerAttrIndividual
) => {
	return {
		type: SET_CUSTOMER_ATTR_INDIVIDUAL,
		payload
	}
}

export const customerAttrIndividualApplySuccess = (
	payload: ICrudApplyCustomerAttrIndividualRes
) => {
	return {
		type: SET_CUSTOMER_ATTR_INDIVIDUAL_SUCCESS,
		payload
	}
}
export const customerAttrGlobalAssignConfirm = (
	payload: ICrudCustomerAttrGlobalAssignConfirm
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM,
		payload
	}
}

export const customerAttrGlobalAssignConfirmSuccess = (
	payload: ICrudCustomerAttrGlobalAssignConfirmRes
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
		payload
	}
}

export const customerAttrGlobalAssignEdit = (
	payload: ICrudCustomerAttrGlobalAssignEdit
) => {
	return {
		type: EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const customerAttrGlobalAssignEditRes = (
	payload: ICrudCustomerAttrGlobalAssignEditRes
) => {
	return {
		type: EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const customerAttrGlobalAssign = (
	payload: ICrudCustomerAttrGlobalAssign
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const customerAttrGlobalAssignSuccess = (
	payload: ICrudCustomerAttrGlobalAssignResponse
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const customerAttrGlobalAssignPaginate = (
	payload: ICrudCustomerAttrGlobalAssignPaginate
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION,
		payload
	}
}

export const customerAttrGlobalAssignPaginateSuccess = (
	payload: ICrudCustomerAttrGlobalAssignPaginateRes
) => {
	return {
		type: SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
		payload
	}
}
export const customerCleanButton = () => ({
	type: CLEAR_CUSTOMER_ATTR_GLOBAL
})
